import Cookies from 'js-cookie';
import { Component } from 'react';
import { connect } from 'react-redux';

import { CheckoutLayout, Title, CheckoutInner } from 'common/components/layout';
import { getCartForHostedPayment } from 'redux/cart/actions';

class HostedPayment extends Component {
  componentDidMount() {
    const { props } = this;
    let successFunction;
    if (Cookies.get('customerToken')) {
      successFunction = (cart) => {
        props.history.push(`/checkout/receipt/${cart.orderId}`);
      };
    } else {
      successFunction = (cart) => {
        props.history.push(
          `/checkout/receipt?orderNumber=${
            cart.orderNumber
          }&email=${encodeURIComponent(cart.email)}`
        );
      };
    }
    const errorFunction = () => {
      props.history.push(`/checkout`);
    };
    props.getCartForHostedPayment(successFunction, errorFunction);
  }

  render() {
    const { settings, cart } = this.props;
    if (!settings.data || !cart.data) {
      return (
        <CheckoutLayout
          title="Checkout HostedPayment"
          loading
          showSideCart={false}
        >
          <CheckoutInner>
            <Title>Checkout</Title>
          </CheckoutInner>
        </CheckoutLayout>
      );
    }
    return (
      <CheckoutLayout title="Checkout HostedPayment" showSideCart={false}>
        <CheckoutInner settings={settings}>
          <Title>Checkout</Title>
          The hosted payment provider is still processing the payment. Please
          check back here within the next 30 minutes to see if your order has
          been processed.
        </CheckoutInner>
      </CheckoutLayout>
    );
  }
}

const mapStateToProps = (state) => ({
  settings: state.setting,
  cart: state.cart
});

export default connect(mapStateToProps, { getCartForHostedPayment })(
  HostedPayment
);
